export default "__VITE_ASSET__DRojuczD__"